import { JSX, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  loadInitialAuthenticationStateAsync,
  logoutAsync,
  selectInitializationStatus,
  setAuthenticationError,
  updateAuthenticationState,
} from "../../features/authentication/authenticationSlice";
import userManager from "../../features/authorization/authService";
import { User } from "oidc-client";
import { serializeOidcUser } from "../../features/authentication/serializeUser";

const InitializeAuth = ({ children }: { children: JSX.Element }) => {
  const initializationStatus = useAppSelector(selectInitializationStatus);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (initializationStatus === "not-initialized") {
      dispatch(loadInitialAuthenticationStateAsync());
    }
  }, [dispatch, initializationStatus]);
  useEffect(() => {
    const signSilent = () => {
      userManager
        .signinSilent()
        .then((user: User) => {
          const serializableUser = serializeOidcUser(user);
          dispatch(updateAuthenticationState(serializableUser));
        })
        .catch((error) => {
          dispatch(setAuthenticationError(error.message));
          dispatch(logoutAsync());
        });
    };
    userManager.events.addAccessTokenExpired(() => {
      signSilent();
    });
  }, [dispatch]);
  if (initializationStatus === "initialized") {
    return children;
  }

  return <></>;
};
export default InitializeAuth;
